// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Jm38E","label":"styles_label___MuO6"};